import { apiCall } from './gqlClient';
const GETWORKOUTS_QUERY = "\n  query getWorkouts {\n    getWorkouts\n    {\n      id\n\t\t\tproviderId\n\t\t\ttitle\n\t\t\tdescription\n\t\t\tlevel\n\t\t\tdateCreated\n\t\t\timageId\n\t\t\tthumbnailUrl\n\t\t\tprice\n\t\t\tactive\n      ...fragments\n    }\n  }";
export const getWorkoutsApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETWORKOUTS_QUERY,
    variables: {},
    fragments
  });
};
const GETWORKOUTDETAILS_QUERY = "\n  query getWorkoutDetails($id: String!, $userId: Int, $groupId: Int) {\n    getWorkoutDetails(id: $id, userId: $userId, groupId: $groupId)\n    {\n      id\n\t\t\tproviderId\n\t\t\ttitle\n\t\t\tdescription\n\t\t\tlevel\n\t\t\tdateCreated\n\t\t\timageId\n\t\t\tthumbnailUrl\n\t\t\tprice\n\t\t\tactive\n      ...fragments\n    }\n  }";
export const getWorkoutDetailsApiCall = async function (_ref) {
  let {
    id,
    userId,
    groupId
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETWORKOUTDETAILS_QUERY,
    variables: {
      id,
      userId,
      groupId
    },
    fragments
  });
};
const CREATEWORKOUT_QUERY = "\n  mutation createWorkout($request: WorkoutInput!) {\n    createWorkout(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const createWorkoutApiCall = async function (_ref2) {
  let {
    request
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATEWORKOUT_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const UPDATEWORKOUT_QUERY = "\n  mutation updateWorkout($request: WorkoutUpdateInput!) {\n    updateWorkout(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const updateWorkoutApiCall = async function (_ref3) {
  let {
    request
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATEWORKOUT_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const CREATECIRCUIT_QUERY = "\n  mutation createCircuit($workoutId: String!, $title: String!) {\n    createCircuit(workoutId: $workoutId, title: $title)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const createCircuitApiCall = async function (_ref4) {
  let {
    workoutId,
    title
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATECIRCUIT_QUERY,
    variables: {
      workoutId,
      title
    },
    fragments
  });
};
const UPDATECIRCUIT_QUERY = "\n  mutation updateCircuit($request: CircuitInput!) {\n    updateCircuit(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const updateCircuitApiCall = async function (_ref5) {
  let {
    request
  } = _ref5;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATECIRCUIT_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const CREATECIRCUITEXERCISE_QUERY = "\n  mutation createCircuitExercise($circuitId: String!) {\n    createCircuitExercise(circuitId: $circuitId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const createCircuitExerciseApiCall = async function (_ref6) {
  let {
    circuitId
  } = _ref6;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATECIRCUITEXERCISE_QUERY,
    variables: {
      circuitId
    },
    fragments
  });
};
const UPDATECIRCUITEXERCISE_QUERY = "\n  mutation updateCircuitExercise($request: CircuitItemInput!) {\n    updateCircuitExercise(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const updateCircuitExerciseApiCall = async function (_ref7) {
  let {
    request
  } = _ref7;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATECIRCUITEXERCISE_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const CREATECIRCUITEXERCISEEQUIPMENT_QUERY = "\n  mutation createCircuitExerciseEquipment($request: CircuitExerciseEquipmentInput!) {\n    createCircuitExerciseEquipment(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const createCircuitExerciseEquipmentApiCall = async function (_ref8) {
  let {
    request
  } = _ref8;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATECIRCUITEXERCISEEQUIPMENT_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const UPDATECIRCUITEXERCISEEQUIPMENT_QUERY = "\n  mutation updateCircuitExerciseEquipment($request: CircuitExerciseEquipmentInput!) {\n    updateCircuitExerciseEquipment(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const updateCircuitExerciseEquipmentApiCall = async function (_ref9) {
  let {
    request
  } = _ref9;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATECIRCUITEXERCISEEQUIPMENT_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const DELETEWORKOUT_QUERY = "\n  mutation deleteWorkout($id: String!) {\n    deleteWorkout(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const deleteWorkoutApiCall = async function (_ref0) {
  let {
    id
  } = _ref0;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: DELETEWORKOUT_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const DUPLICATEWORKOUT_QUERY = "\n  mutation duplicateWorkout($id: String!) {\n    duplicateWorkout(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const duplicateWorkoutApiCall = async function (_ref1) {
  let {
    id
  } = _ref1;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: DUPLICATEWORKOUT_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const TOGGLEWORKOUTSTATUS_QUERY = "\n  mutation toggleWorkoutStatus($id: String!, $active: Boolean!) {\n    toggleWorkoutStatus(id: $id, active: $active)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const toggleWorkoutStatusApiCall = async function (_ref10) {
  let {
    id,
    active
  } = _ref10;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: TOGGLEWORKOUTSTATUS_QUERY,
    variables: {
      id,
      active
    },
    fragments
  });
};
const DELETEWORKOUTITEM_QUERY = "\n  mutation deleteWorkoutItem($id: String!) {\n    deleteWorkoutItem(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const deleteWorkoutItemApiCall = async function (_ref11) {
  let {
    id
  } = _ref11;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: DELETEWORKOUTITEM_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const DELETEWORKOUTEQUIPMENTOVERRIDEITEM_QUERY = "\n  mutation deleteWorkoutEquipmentOverrideItem($id: String!) {\n    deleteWorkoutEquipmentOverrideItem(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const deleteWorkoutEquipmentOverrideItemApiCall = async function (_ref12) {
  let {
    id
  } = _ref12;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: DELETEWORKOUTEQUIPMENTOVERRIDEITEM_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const REORDERCIRCUITITEMS_QUERY = "\n  mutation reorderCircuitItems($firstId: String!, $secondId: String!) {\n    reorderCircuitItems(firstId: $firstId, secondId: $secondId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tname\n\t\t\tidx\n\t\t\ttitle\n      ...fragments\n    }\n  }";
export const reorderCircuitItemsApiCall = async function (_ref13) {
  let {
    firstId,
    secondId
  } = _ref13;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: REORDERCIRCUITITEMS_QUERY,
    variables: {
      firstId,
      secondId
    },
    fragments
  });
};